import { Card, CardContent, Stack, Box, Typography, IconButton } from '@mui/material';
import { Lock, Info, TrendingDown } from '@mui/icons-material';
import { useTranslation } from '@/kit/useTranslation';

export default function BlockedAmountCard({ amount, onShowInfo }) {
  const { t } = useTranslation();
  if (amount <= 0) return null;

  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 3,
        border: '1px solid #ff980030',
        bgcolor: '#ff980008',
      }}
    >
      <CardContent>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
          <Box>
            <Stack direction="row" alignItems="center" spacing={1} mb={1}>
              <Lock sx={{ fontSize: 20, color: '#ff9800' }} />
              <Typography variant="body2" color="text.secondary">
                {t('payment.wallet.blockedAmount')}
              </Typography>
              <IconButton size="small" onClick={onShowInfo} sx={{ ml: 0.5 }}>
                <Info sx={{ fontSize: 16, color: '#ff9800' }} />
              </IconButton>
            </Stack>
            <Typography variant="h5" fontWeight={700} color="#ff9800">
              ₹{amount || 0}
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
              {t('payment.wallet.releasedAfterDelivery')}
            </Typography>
          </Box>
          <IconButton size="small">
            <TrendingDown sx={{ color: '#ff9800' }} />
          </IconButton>
        </Stack>
      </CardContent>
    </Card>
  );
}
